import React from "react";
import { socket } from "../../../../lib/socketio";
import { GroupTemplate } from "../../../Definitions/cl";
import { Grid, Button, Label } from "semantic-ui-react";
import PCSColumn from "../../../Monitor/PCSColumn";
import PCSMacro from "../../../Macros/PCSMacro";
import Footer from "../../Footer";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { IO_WRITE, isAuthorized } from "../../../../lib/authorization";

const PCSFaultsMAIN = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 46 }, { display_id: 1 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'Footer' ? [t] : []);
    t.display_id === 1 ? [t] : [],
  );
  const GenTags = tags.flatMap((t) => (t.display_id === 46 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);
  const GroupTags = GroupTemplate(GenTags, "tag_display_subgroup");

  const FaultTags = Object.keys(GroupTags[0]).map((i) =>
    GroupTags[0][i].sort((a, b) => parseFloat(a.bit) - parseFloat(b.bit)),
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <p style={{ alignSelf: "flex-end" }}>
        {" "}
        Normal
        <Label circular horizontal empty size="large" color="green" />
      </p>
      <p style={{ alignSelf: "flex-end" }}>
        {" "}
        Warning/Fault
        <Label circular horizontal empty size="large" color="red" />
      </p>
      <div style={styles.div}>
        <h1 style={styles.header}>{display[0]} </h1>
        {(electronApp || isAuthorized(user.hmi_role, IO_WRITE)) && (
          <Button.Group>
            <PCSMacro
              title={"RESET FAULTS"}
              channel={"RESET PCS MAIN"}
              option={1}
              description={"Do you wish to Reset PCS Faults (MAIN)?"}
            />
            <PCSMacro
              title={"PCS SHUTDOWN"}
              channel={"PCS SHUTDOWN MAIN"}
              option={1}
              description={"Do you wish to Shutdown the PCS (Return to I___)?"}
            />
            <PCSMacro
              title={"CHECKOUT MODE"}
              description={"Confirm Checkout Mode?"}
              option={2}
              data={data[2650]}
              tagid={2650}
            />
          </Button.Group>
        )}
        <div style={{ marginTop: "30px" }}>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            {FaultTags.map((c, i) => (
              <PCSColumn
                key={i}
                index={i}
                option={2}
                column={c}
                data={data}
                width={"500px"}
              />
            ))}
          </Grid>
        </div>
        <Footer tags={FooterTags} data={data} option={"MAIN"} />
      </div>
    </>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "15px",
  },
  toggle: {
    marginTop: "5px",
    marginBottom: "25px",
    alignItems: "center",
  },
};

export default PCSFaultsMAIN;
